import React, { useEffect, useState, useContext } from "react";
import "../../../assests/css/teachers/TeacherNotification.css";
import {
  ArrowLeft,
  Calendar,
  Bell,
  CheckCheck,
} from "lucide-react";
import TeacherMasterLayout from "../../../layouts/TeacherMasterLayout";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import Swal from "sweetalert2";

const TeacherNotifications = () => {

  const { baseUrl } = useContext(AppContext);
  const [errorMessage, setErrorMessage] = useState('');

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [unreadCount, setUnreadCount] = useState(0);
  const teacherData = JSON.parse(localStorage.getItem("teacher"));

  // Fetch Notifications
  useEffect(() => {
    viewAllNotification();
  }, []);

  const viewAllNotification = () => {
    setLoading(true);
    const formData = new FormData();
formData.append("ngteacher_id", teacherData?.id);
    axios.post(`${baseUrl}/teacher/notification/viewAllNotification`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
        "Content-Type": "multipart/form-data"
      }
    })
      .then((response) => {
        console.log(response.data);
       if (response.data.success == true) {

  setNotifications(response.data.notifications);

  const unread = response.data.notifications.filter(
    (item) => item.isRead == 0
  ).length;

  setUnreadCount(unread);
}
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const markAsRead = (item) => {
    const formData = new FormData();
    formData.append('id', item.id);
    axios.post(`${baseUrl}/teacher/notification/markAsRead`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // "Authorization": `Bearer ${authToken}`
      },
    })
      .then((response) => {
        console.log("response called", response.data);
       if (response.data.success == true) {

  setNotifications(prev =>
    prev.map(n =>
      n.id === item.id
        ? { ...n, isRead: 1 }
        : n
    )
  );

  setUnreadCount(prev => Math.max(prev - 1, 0));
}
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const markAllAsRead = () => {
    const formData = new FormData();
formData.append("ngteacher_id", teacherData?.id);
    axios.post(`${baseUrl}/teacher/notification/markAllAsRead`, formData, {
      headers: {
        // "Authorization": `Bearer ${authToken}`
        "Content-Type": "multipart/form-data"
      }
    })
      .then((response) => {
        console.log("response called", response.data);
        if (response.data.success == true) {
          // ── Sab notifications ki isRead true karo ──
          // setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
          viewAllNotification();
          Swal.fire({
            icon: 'success',
            title: 'Done',
            text: 'All Notification Marked as Read',
            confirmButtonText: 'Okay'
          })
        }
        else if (response.data.success == false) {
          setErrorMessage(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <TeacherMasterLayout>

      {/* Topbar */}
      <header className="ta-topbar">
        <h3>Welcome, Teacher 👋</h3>
        <div className="ta-profile">👤</div>
      </header>

      <div className="tp-notify-wrapper">
        <div className="tp-notify-page">

          {/* Header */}
          <div className="tp-notify-header">
            <div className="tp-notify-header-left">
              <ArrowLeft className="tp-notify-back" />

              <h2>
                Notifications ({unreadCount})
              </h2>
            </div>

            <button
              className="adm-notif-page__action-btn adm-notif-page__action-btn--secondary"
              onClick={markAllAsRead}
            >
              <CheckCheck size={18} />
              <span>Mark All as Read</span>
            </button>
            {/* <span className="tp-notify-read">
              Mark all as read
            </span> */}
          </div>

          {/* Highlight Notification */}
          {notifications.length > 0 && (
            <div className="tp-notify-highlight">

              <div className="tp-notify-highlight-icon">
                <Calendar />
              </div>

              <div className="tp-notify-highlight-content">

                <span className="tp-notify-time">
                  Latest Notification
                </span>

                <h3>
                  {notifications[0]?.title}
                </h3>

                <p>
                  {notifications[0]?.message}
                </p>

                <button className="tp-notify-btn-primary">
                  View Details
                </button>

              </div>
            </div>
          )}

          {/* Section */}
          <h4 className="tp-notify-section">
            Recent Notifications
          </h4>

          {/* Loading */}
          {loading && (
            <p className="tp-loading-text">
              Loading notifications...
            </p>
          )}

          {/* Error */}
          {error && (
            <p className="tp-error-text">
              {error}
            </p>
          )}

          {/* Notifications List */}
          <div className="tp-notify-list">

            {notifications.map((item) => (

              <div
                key={item.id}
                className={`tp-notify-item ${!item.isRead ? "tp-unread" : ""}`}
              >

                <div className="tp-notify-icon">
                  <Bell />
                </div>

                <div className="tp-notify-text">

                  <h5>
                    {item.title}
                  </h5>

                  <p>
                    {item.message}
                  </p>

                </div>

                <span className="tp-notify-time-sm">
                  {item.created_at}
                </span>

              </div>
            ))}

          </div>

          {/* Empty State */}
          {!loading && notifications.length === 0 && (
            <div className="tp-notify-empty">
              <Bell />
              <p>You are all caught up 🎉</p>
            </div>
          )}

        </div>
      </div>

    </TeacherMasterLayout>
  );
};

export default TeacherNotifications;